import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';
import { FiPlus, FiMinus } from 'react-icons/fi';

export default function IndicadoresSustentabilidade({ repeatableFields, addRepeatableField, removeRepeatableField }) {
  const { watch } = useFormContext();
  
  const projetosRenovaveis = watch('projetos_renovaveis') === 'sim';
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre indicadores de sustentabilidade do município, incluindo energia renovável e gestão de resíduos.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="projetos_renovaveis"
          label="Presença de projetos com fontes renováveis (solar, eólica, biomassa)"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se o município possui projetos de geração de energia a partir de fontes renováveis"
        />
        
        {projetosRenovaveis && (
          <div className="mt-4">
            {/* Campos repetíveis para projetos */}
            {repeatableFields.projeto.map((item) => (
              <div key={item.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-md font-medium">Projeto {item.id}</h3>
                  {item.id !== 1 && (
                    <button 
                      type="button" 
                      onClick={() => removeRepeatableField('projeto', item.id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FiMinus className="mr-1" /> Remover
                    </button>
                  )}
                </div>

                <div className="mt-2">
                  <FormField
                    name={`projeto_capacidade_${item.id}`}
                    label="Capacidade instalada (MW)"
                    type="numeric"
                    thousandSeparator="."
                    decimalSeparator=","
                    suffix=" MW"
                    placeholder="Digite a capacidade instalada em MW"
                    helpText="Capacidade instalada em Megawatts"
                  />
                </div>
              </div>
            ))}
            
            <div className="mb-4">
              <button 
                type="button" 
                onClick={() => addRepeatableField('projeto')}
                className="flex items-center text-blue-600 hover:text-blue-800"
              >
                <FiPlus className="mr-1" /> Adicionar outro projeto
              </button>
            </div>
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <FormField
          name="reciclagem_taxa"
          label="Taxa de reciclagem (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem de resíduos sólidos reciclados"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
        
        <FormField
          name="aterros_sanitarios"
          label="Presença de aterros sanitários"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se o município possui aterros sanitários adequados"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="poluicao_ar"
          label="Índice de poluição do ar"
          placeholder="Digite o índice de poluição do ar"
          helpText="Índice de qualidade do ar conforme padrões oficiais"
        />
        
        <FormField
          name="recursos_hidricos"
          label="Qualidade dos recursos hídricos"
          placeholder="Descreva a qualidade dos recursos hídricos"
          helpText="Informações sobre a qualidade dos recursos hídricos locais"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao8"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao8"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
